import request from '@/utils/request'
import host from '@/api/base/host'

const path = host.path('dev', { module: 'order', dev: 'activity' })
export default {
  pullnewDetail(data) {
    const url = path('getNewUser') + '?openId=' + data.openId
    return request({ url: url, method: 'get', data })
  }
}
